import React from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { CASINO_VIDEO_URL } from '../utils/constants';

export default function TvIframe() {
    const location=useLocation();
    const prams=useParams()
    var GAME_ID =prams?.id

  return (
    <iframe src={ `https:bigpro.zapto.org/diamondoriginaltv?gmid=${GAME_ID}` }/>

    //  src={` https://bigpro.zapto.org/diamondoriginaltv?gmid=${gameEvent?.oldgmid}`}
    
  )
}
